'use client';

import { Fragment, useEffect, useState } from 'react';
import { Hamburger } from './components/Hamburger/Hamburger';
import style from './MobileMenu.module.scss';
import { NavbarMobile } from '@/new/components/Header/components/MobileMenu/components/NavbarMobile/NavbarMobile';

export const MobileMenu = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

  const toggleMenu = (): void => {
    setMobileMenuOpen((open: boolean) => !open);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 662) {
        document.body.style.overflow = 'auto';
      } else {
        if (mobileMenuOpen) {
          document.body.style.overflow = 'hidden';
        }
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [mobileMenuOpen]);

  return (
    <Fragment>
      <Hamburger isOpen={mobileMenuOpen} onChange={toggleMenu}/>
      {mobileMenuOpen && (
        <div className={style.mobileMenu}>
          <div className={style.mobileMenuInner}>
            <NavbarMobile onMenuToggle={toggleMenu} />
          </div>
        </div>
      )}
    </Fragment>
  );
};
